export default `
<svg
  aria-hidden="true"
  aria-label="dev"
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
>
  <path d="M6 12l-4-4 4-4m4 0l4 4-4 4" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
